<template>
  <div
    class="myPies"
    id="myChart"
    :style="{ width: '100%', height: '200px' }"
  ></div>
</template>

<script>
  // require('echarts/lib/chart/pie') //饼图
  // //下面的是需要的提示框
  // require('echarts/lib/component/tooltip')
  // require('echarts/lib/component/title')
  // require('echarts/lib/component/legend')
  import * as echarts from 'echarts';
  export default {
    name: 'echart-attendance',
    props: {
      itemsData: {
        type: Array
      },
      rateTotal: {
        type: String
      }
    },
    mounted() {
      this.drawLine();
    },
    watch: {
      itemsData: {
        handler(newName, oldName) {
          if (oldName) {
            this.drawLine();
          }
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      /**
       * echarts
       *  **/
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('myChart'));
        let option;
        // 绘制图表
        option = {
          title: {
            show: true,
            text: '部门正常出勤率',
            subtext: this.rateTotal,
            x: 'center',
            y: '32%',
            textStyle: {
              fontSize: 14,
              color: '#ccc',
              fontStyle: 'normal',
              fontWeight: 'normal'
            },
            subtextStyle: {
              fontFamily: 'Arial, Verdana, sans...',
              fontSize: 22,
              color: '#000',
              fontStyle: 'normal',
              fontWeight: 'normal'
            }
          },
          tooltip: {
            trigger: 'item'
          },

          icon: 'circle',
          legend: {
            bottom: '0%',
            left: 'center'
            // type: 'scroll',
          },
          series: [
            {
              name: '团队考勤',
              type: 'pie',
              center: ['50%', '40%'], //这个属性调整图像的位置
              radius: ['55%', '75%'],
              avoidLabelOverlap: false,
              minAngle: 20,
              itemStyle: {
                normal: {
                  label: {
                    position: 'inner',
                    show: true,
                    formatter: '{c}'
                  }
                }
              },

              data: this.itemsData
            }
          ]
        };
        option &&
          myChart.setOption(option);
      }
    }
  };
</script>
